import type { Transition, Variants } from 'framer-motion';

/** Shared spring configs — physics rather than eased tweens. */
export const spring: Record<'snappy' | 'smooth' | 'heavy', Transition> = {
  snappy: { type: 'spring', stiffness: 520, damping: 32, mass: 0.7 },
  smooth: { type: 'spring', stiffness: 280, damping: 26, mass: 1 },
  heavy: { type: 'spring', stiffness: 190, damping: 28, mass: 1.3 },
};

/** Strong ease-out curve for entrances and exits. */
export const easeOutExpo = [0.23, 1, 0.32, 1] as const;

export function staggerContainer(step = 0.05, delay = 0.04): Variants {
  return {
    hidden: {},
    show: { transition: { staggerChildren: step, delayChildren: delay } },
  };
}

export function riseItem(reduce: boolean | null, travel = 16): Variants {
  if (reduce) {
    return {
      hidden: { opacity: 0 },
      show: { opacity: 1, transition: { duration: 0.15, ease: 'easeOut' } },
    };
  }
  return {
    hidden: { opacity: 0, y: travel },
    show: { opacity: 1, y: 0, transition: spring.smooth },
  };
}
